<script setup>
import { computed } from "vue";

import PageContentRenderer from "@campaign-js/Components/PageContentRenderer.vue";
import CampaignLayout from "@campaign-js/Layouts/CampaignLayout.vue";
import PrimaryButton from "@campaign-js/Pages/Home/Partials/PrimaryButton.vue";
import { usePage } from "@inertiajs/vue3";

const props = defineProps({
  campaign: {
    type: Object,
    required: true
  },
  pageMeta: {
    type: Object,
    required: false
  }
});

const _page = usePage();
const isLoggedIn = computed(() => !!_page.props.user);
const getBackgroundColor = computed(() => props.campaign.settings.background_color);
</script>

<template>
  <CampaignLayout :page="pageMeta">
    <PageContentRenderer :campaign="campaign" :page-meta="pageMeta" />
    <!--end::primary-page-->

    <template #footer>
      <div v-if="campaign.settings.action" class="no-padding relative">
        <PrimaryButton :campaign="campaign" :is-logged-in="isLoggedIn" :background-color="getBackgroundColor" />
        <!--end::primary-action-button-->
      </div>
    </template>
  </CampaignLayout>
</template>
